import isEmail from "validator/lib/isEmail";

export interface WiderrufInputs {
  firstName: string;
  lastName: string;
  email: string;
  orderNumber: string;
}

export interface WiderrufSupport {
  firstName: string;
  lastName: string;
  email: string;
  orderNumber: string;
}

export function validateWiderrufStep1(
  inputs: WiderrufInputs,
  support: WiderrufSupport,
): boolean {
  let valid = true;

  if (!inputs.firstName || inputs.firstName.trim() === "") {
    support.firstName = "Bitte geben Sie Ihren Vornamen ein";
    valid = false;
  } else {
    support.firstName = "";
  }

  if (!inputs.lastName || inputs.lastName.trim() === "") {
    support.lastName = "Bitte geben Sie Ihren Nachnamen ein";
    valid = false;
  } else {
    support.lastName = "";
  }

  if (!isEmail(inputs.email)) {
    support.email = "Fehlerhafte E-Mail-Adresse";
    valid = false;
  } else {
    support.email = "";
  }

  if (!inputs.orderNumber || inputs.orderNumber.trim() === "") {
    support.orderNumber = "Bitte geben Sie Ihre Bestellnummer ein";
    valid = false;
  } else {
    support.orderNumber = "";
  }

  return valid;
}
